const mainSearchForm = {
  flights: "Πτήσεις", // translated
  tours: "Περιηγήσεις", // translated
  hotel: "Ξενοδοχειο", // translated
  hotels: "Ξενοδοχεία", // translated
  services: "Υπηρεσίες", // translated
  search: "ΑΝΑΖΗΤΗΣΗ", // translated
  destination: "Προορισμός", // translated
  includedServices: "Συμπεριλαμβανόμενες Υπηρεσίες", // translated
  packageDuration: "Διάρκεια πακέτου", // translated
  checkInOut: "Check in/out", // translated
  guests: "Καλεσμένοι", // translated
  adults: "Ενήλικες", // translated
  children: "Παιδιά", // translated
  child: "Παιδί", // translated
  age: "Ηλικία", // translated
  yearsOld: "Χρονών", // translated
  rooms: "Δωμάτια", // translated
  close: "Κλείσε", // translated
  searchType: "Τύπος αναζήτησης", // translated
  accommodation: "Κατάλυμα", // translated
  transfers: "Μεταγραφές", // translated
  toursExperiences: "Περιηγήσεις/Εμπειρίες", // translated
  nights: "Νύχτες", // translated
  days: "Ημέρες", // translated
  packageType: "Τύπος Πακέτου", // translated
  tourType: "Τύπος ξενάγησης", // translated
  packages: "Πακέτα", // translated
  cars: "Αυτοκίνητα", // translated
  cruises: "Κρουαζιέρες", // translated
  infantsInSeat: "Βρέφη στο κάθισμα", // translated
  infantsOnLap: "Βρέφη στην αγκαλιά", // translated
  airport: "Αεροδρόμιο", // translated
  passengers: "Επιβάτες", // translated
  departureReturn: "Ημερομηνίες αναχώρησης και επιστροφής", // translated
  origin: "Προέλευση", // translated
  roundTrip: "Ταξίδι μετ επιστροφής", // translated
  isRoundTrip: "Είναι μετ' επιστροφής", // translated
  dream_packages: "Πακέτα Dream", // translated
  partying: "Πάρτι", // translated
  thingsToDo: "Πραγματα να κανεις", // translated
};

export default mainSearchForm;
